import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';

@Injectable()
export class BankService {
    private endPoint: String = "/banks";

    constructor(private httpClient: HttpClient) { }

    async getBanks() {
        let itemsServer = await this.httpClient.get(`${this.endPoint}`);
        return itemsServer;
    }

    async postBank(bank: any) {
        let itemsServer = await this.httpClient.post(`${this.endPoint}`, bank);
        return itemsServer;
    }

    async updateBank(bank: any) {
        let itemsServer = await this.httpClient.update(`${this.endPoint}`, bank.bankCode, bank);
        return itemsServer;
    }

    async removeBank(bankCode: any) {
        let itemsServer = await this.httpClient.delete(`${this.endPoint}`, bankCode);
        return itemsServer;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/bank.service.ts